import ddt from '@wix/da-ddt';
import { WriterError, WriterPopupType } from './types';
const logger = ddt.createLogger('writer.saga');
/** Handles a subset of writer errors related to media content counts */ function convertMediaContentViolationToWriterError(violation) {
    switch(violation){
        case 'wix-draft-plugin-giphy':
            return WriterError.GifCountExceeded;
        case 'DA_COMM_EMOTE|DA_OFF_EMOTE':
            return WriterError.EmoteCountExceeded;
        case 'wix-draft-plugin-image':
            return WriterError.ImageCountExceeded;
        case 'mention':
            return WriterError.MentionCountExceeded;
        case 'spam':
            return WriterError.Spam;
        default:
            return WriterError.Unspecified;
    }
}
export function convertResponseErrorToWriterError(errorDetails = {}) {
    if (errorDetails.errorType === 'media_content_violation') {
        var _errorDetails_violations;
        const violations = (_errorDetails_violations = errorDetails.violations) !== null && _errorDetails_violations !== void 0 ? _errorDetails_violations : [];
        if (violations.length > 0) {
            // The UI spec doesn't cover cases for multiple violations, so we'll just take the first one
            return convertMediaContentViolationToWriterError(violations[0]);
        }
    }
    switch(errorDetails.editorRaw){
        case 'editorRaw has incorrect length':
            return WriterError.ContentTooLong;
        default:
            break;
    }
    return WriterError.Unspecified;
}
export function getWriterEndpoint(path, type = WriterPopupType.JOURNAL) {
    switch(type){
        case WriterPopupType.LITERATURE:
            return `/literature${path}`;
        default:
            return `/journal${path}`;
    }
}
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                journal: 'error'
            };
        }
        logger.log('faking the response!');
        const { deviationsByType } = require('@wix/da-sample-data'); // eslint-disable-line global-require
        const deviation = deviationsByType.journal[0];
        if (options.url === '/journal/create' || options.url === '/journal/content/update' || options.url === '/literature/create' || options.url === '/literature/content/update') {
            deviation.title = options.data.title;
            deviation.publishedTime = undefined;
            deviation.textContent = {
                excerpt: options.data.editorSnippet,
                html: {
                    type: 'tiptap',
                    markup: options.data.editorRaw,
                    features: options.data.editorFeatures
                }
            };
        }
        return {
            deviation
        };
    }
}

//# sourceMappingURL=utils.js.map